import { createGlobalStyle } from "styled-components";

export const ResetCss = createGlobalStyle`
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@200;300;400;500;600;700;800;900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,800;1,900&display=swap');
    *, *::before, *::after {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: Poppins,Inter, sans-serif;
    }
    body {
    overflow: hidden;
    }

    .container {
        width: 100vw;
  height: 100vh;
  position: relative;
    }

    .actived {
        width: 250px !important;
        border-radius: 45px !important;
        justify-content: flex-start !important;
        padding-left: 15px;
        text-align: left !important;

    }

    .actived-text {
        margin-left: 5px;
    }
`;
